import { Attachment as OriginalAttachment, Card as OriginalCard, useChatContext } from 'stream-chat-react';
import type { AttachmentProps, CardProps } from 'stream-chat-react';
import Video from '../Video/Video';
import { addUserTokenToMomentFeedbackUrl } from '../../utilities/addUserTokenToMomentFeedbackUrl';
import { SuggestionAttachment, suggestionAttachmentType } from './SuggestionAttachment';
import type { SuggestionAttachmentProps } from './SuggestionAttachment';
import type { StreamChatGenerics } from '../../types';

const Card = (props: CardProps) => {
  const { client } = useChatContext<StreamChatGenerics>();
  const { title_link: titleLink } = props;

  if ((props as unknown as { type?: string }).type === suggestionAttachmentType) {
    return <SuggestionAttachment {...(props as unknown as SuggestionAttachmentProps)} />;
  }

  const decoratedTitleLink = titleLink
    ? addUserTokenToMomentFeedbackUrl(titleLink,client?.user?.id)
    : titleLink;

  return <OriginalCard {...props} title_link={decoratedTitleLink} />
}

const Attachment = (props: AttachmentProps<StreamChatGenerics>) => {
  return <OriginalAttachment {...props} Card={Card} Media={Video} />
}

export default Attachment;
